import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-line chart",
  "use": "icon-line chart-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-line chart\"><defs><style type=\"text/css\"></style></defs><path d=\"M107 962a45 45 0 0 1-45-45V354.5a90 90 0 0 1 90-90h180V152a90 90 0 0 1 90-90h180a90 90 0 0 1 90 90v315h180a90 90 0 0 1 90 90v360a45 45 0 0 1-45 45H107z m765-405h-180v315h180v-315zM332 354.5H152V872h180V354.5zM602 152H422v720h180V152z\" p-id=\"739\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol